export default __webpack_public_path__ + "static/media/selected-glasses-icon.54bda2dd.svg";